import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
const router = new Router({
  routes: [{
    path: '/main',
    component: resolve => require(["../components/nav/main.vue"], resolve),
    children: [{
      name: '/main/search',
      path: '/main/search',
      component: resolve => require(["../components/main/search.vue"], resolve)
    }]
  }, {
    path: "/home",
    component: resolve => require(["../components/nav/home.vue"], resolve),
    children: [{
      name: '/home/welcome',
      path: '/home/welcome',
      component: resolve => require(["../components/main/welcome.vue"], resolve)
    }, {
      name: '/home/come',
      path: '/home/come',
      component: resolve => require(["../components/main/come.vue"], resolve)
    }, {
      name: '/home/login',
      path: '/home/login',
      component: resolve => require(["../components/main/login.vue"], resolve)
    }, {
      name: '/home/phone',
      path: '/home/phone',
      component: resolve => require(["../components/main/phone.vue"], resolve)
    }, {
      name: '/home/international',
      path: '/home/international',
      component: resolve => require(["../components/main/international.vue"], resolve)
    }, {
      name: '/home/statistics',
      path: '/home/statistics',
      component: resolve => require(["../components/main/statistics.vue"], resolve)
    }, {
      name: '/home/taxcensus',
      path: '/home/taxcensus',
      component: resolve => require(["../components/main/taxcensus.vue"], resolve)
    }, {
      path: '/home/detail',
      component: resolve => require(["../components/main/detail.vue"], resolve)
    },  {
      path: '/home/thirdDetail',
      component: resolve => require(["../components/main/thirdDetail.vue"], resolve)
    },  {
      path: '/home/callback',
      component: resolve => require(["../components/main/callback.vue"], resolve)
    }, {
      name: '/home/manage',
      path: '/home/manage',
      component: resolve => require(["../components/main/manage.vue"], resolve)
    }, {
      name: '/home/hotwords',
      path: '/home/hotwords',
      component: resolve => require(["../components/main/hotwords.vue"], resolve)
    }, {
      name: '/home/menu',
      path: '/home/menu',
      component: resolve => require(["../components/main/menu.vue"], resolve)
    }, {
      path: '/home/userCenter',
      component: resolve => require(["../components/main/userCenter.vue"], resolve)
    },{
      name: '/home/image',
      path: '/home/image',
      component: resolve => require(["../components/main/image.vue"], resolve)
    },{
      name: '/home/userInfor',
      path: '/home/userInfor',
      component: resolve => require(["../components/main/userInfor.vue"], resolve)
    }, {
      name: '/home/errorcorrection',
      path: '/home/errorcorrection',
      component: resolve => require(["../components/main/errorcorrection.vue"], resolve)
    }]
  }, {
    path: "/uploadfile",
    component: resolve => require(["../components/main/uploadfile.vue"], resolve)
  }, {
    path: "/home/freeDetail",
    component: resolve => require(["../components/main/freeDetail.vue"], resolve)
  }]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/home/welcome'  || to.path === '/home/thirdDetail' || to.path === '/home/callback') {
    if(from.path === '/home/thirdDetail') {
      next(from.path);
    }else {
      next();
    }
  } else {
    if (localStorage.getItem('userinfo')) {
      var token = JSON.parse(localStorage.getItem('userinfo')).msg;
    }
    if (token === 'null' || token === '') {
      next('/home/welcome');
    } else {
      next();
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js